import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 pt-14 pb-8">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-600 text-background-50 text-lg">
                <i className="ri-plant-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">漫蛙</span>
                <span className="text-xs text-primary-300 tracking-wide">客户端下载中心</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-7 text-primary-200 max-w-md">
              提供漫蛙官网、APP 下载、安卓版、iOS 版与最新版的下载信息汇总，帮助你按设备找到合适的客户端并快速完成安装。
            </p>
          </div>

          <div className="md:col-span-3">
            <h2 className="text-sm font-medium text-background-50">页面导航</h2>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h2 className="text-sm font-medium text-background-50">下载提示</h2>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-primary-200 leading-6">
                <i className="ri-android-line text-accent-400 mt-0.5"></i>
                安卓设备安装前请允许当前来源安装应用。
              </li>
              <li className="flex items-start gap-2.5 text-sm text-primary-200 leading-6">
                <i className="ri-apple-line text-accent-400 mt-0.5"></i>
                iPhone 与 iPad 建议通过应用商店渠道安装。
              </li>
              <li className="flex items-start gap-2.5 text-sm text-primary-200 leading-6">
                <i className="ri-information-line text-accent-400 mt-0.5"></i>
                版本号与更新日期以官方发布为准。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300">© 2026 漫蛙客户端下载中心 · 本站为信息汇总页面</p>
          <a href="#top" className="flex items-center gap-1.5 text-xs text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}